<template>
  <ul class="video-upload__list">
    <li class="video-upload__item" v-if="videoId">
      <div class="video-upload__video-container">
        <video
          v-if="videoSrc"
          id="video"
          class="video-upload__uploaded"
          :src="videoSrc"
          type="video/mp4"
          controls
        ></video>
        <div class="video-upload__iframe-container" v-if="!videoSrc">
          <VimeoPlayer
            :ref="'private-creation-flow-player'"
            :video-id="videoId"
            :player-height="150"
            :options="{ quality: '720p', dnt: 'true' }"
            :controls="true"
          ></VimeoPlayer>
        </div>

        <div class="video-upload__control">
          <button class="video-upload__button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" v-bind:loading="'lazy'" v-bind:class="'video-upload__icon'" v-bind:svg-inline="''" @click="deleteVideo()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15" fill="#FFF" fill-opacity=".68"/><path d="M5.43 7.08h18.6V8H5.43z"/><path fill="#333" d="M22.32 9.02H7.24a.38.38 0 110-.78l15.08.01a.38.38 0 110 .77"/><path fill="#333" d="M19.16 24.2h-8.8c-1.23 0-2.23-1-2.23-2.23V8.64h.77v13.33c0 .81.66 1.47 1.46 1.47h8.8c.81 0 1.47-.66 1.47-1.47V8.64h.77v13.33c0 1.24-1 2.24-2.23 2.24"/><path fill="#333" d="M11.94 20.24a.39.39 0 01-.38-.39V12.8c0-.21.17-.38.38-.38s.39.17.39.38v7.06c0 .22-.18.39-.39.39m2.78.73a.39.39 0 01-.38-.39v-8.52a.38.38 0 11.76 0v8.52c0 .22-.17.39-.38.39m2.96-.73a.39.39 0 01-.38-.39V12.8c0-.21.17-.38.38-.38.22 0 .39.17.39.38v7.06c0 .22-.17.39-.39.39"/><path d="M10.94 3.61h7.64v3.93h-7.64z"/><path fill="#333" d="M18.07 8.64h-.77V6.6a.54.54 0 00-.54-.54h-3.9c-.25 0-.53.2-.53.54v2.04h-.78V6.6c0-.81.69-1.31 1.32-1.31h3.89c.63 0 1.3.5 1.3 1.3v2.05z"/></g></svg>
          </button>
        </div>
      </div>
    </li>
    <li class="video-upload__item" v-if="!videoId">
      <form
        class="video-upload__upload-container"
        method="post"
        action
        enctype="multipart/form-data"
      >
        <div class="spinner__loader-container" v-if="isUploading">
          <div class="spinner--loader"></div>
          <p class="video-upload__progress" v-if="isUploading">
            {{ progressPercent }}%
          </p>
        </div>

        <input
          id="video-file"
          class="video-upload__upload"
          type="file"
          accept="*"
          ref="videoUploadInput"
          @change="uploadChange"
        />
        <label for="video-file" class="video-upload__upload-label">
          <span class="video-upload__upload-button">
            <span class="video-upload__upload-video"></span>
            <span class="video-upload__upload-arrow-container">
              <span class="video-upload__upload-arrow"></span>
            </span>
          </span>
        </label>
      </form>
    </li>
  </ul>
</template>

<script>
import { app } from '@/main'
import { nextTick } from 'vue'
import { vueVimeoPlayer as VimeoPlayer } from 'vue-vimeo-player'
import vimeoUploadInstance from '@/vimeoUpload'

export default {
  mixins: [vimeoUploadInstance],
  components: {
    VimeoPlayer,
  },
  props: {
    eventBus: { default: null, type: Object },
    videoList: {
      default: () => {
        return []
      },
      type: Array,
    },
    videoId: { deafult: '', type: String },
    videoSrc: { default: '', type: String },
  },
  data() {
    return {
      isUploading: false,
      progressPercent: 0,
    }
  },
  methods: {
    videoDelete(index, item) {
      if (!this.eventBus) {
        return false
      }
      this.eventBus.emit('video-deleted-callback', item)
    },
    uploadChange(elm) {
      if (!this.eventBus) {
        return false
      }
      if (elm.target.files && elm.target.files[0]) {
        this.isUploading = true
        this.eventBus.emit('set-lock')
        const owner = this
        const file = elm.target.files[0]

        const errorMessage = this.validateFile(file)
        if (errorMessage) {
          this.releaseLock()
          app.toast.error(errorMessage)
          return
        }

        owner.uploadFileToVimeo(file)
      }
    },
    videosUpdated(videoArray) {
      this.videos = videoArray

      nextTick(() => {
        this.releaseLock()
      })
    },
    getBase64(file) {
      const owner = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        owner.eventBus.emit('video-uploaded-src-callback', reader.result)
      }
    },
    validateFile(file) {
      if (file.type.indexOf('video/') < 0) {
        return 'Den angivne fil er ikke et video format.'
      } else if (file.size > 1000000000) {
        return 'Størrelsen på video filen må ikke overstige 1 GB.'
      } else {
        this.$refs.videoUploadInput.values = ''
        return
      }
    },
    uploadFileToVimeo(f) {
      const owner = this

      var uploader = new vimeoUploadInstance.vimeoUpload({
        /* name: 'Kan ikke udfyldes hvis token ikke har edit mode', description: 'Kan ikke udfyldes hvis token ikke har edit mode',*/
        file: f,
        token: '8afce20ef17c4c31e95ac1d27c51c835',
        onProgress(data) {
          owner.progressPercent = parseInt((data.loaded * 100) / data.total)
        },
        onError() {
          // error message til brugeren af der er sket en fejl
        },
      })
      /*Henter video_id*/

      uploader.__proto__.onUpdateVideoData_ = videoId => {
        owner.getBase64(f)
        owner.saveVideoId(videoId)
        owner.releaseLock()
      }

      this.progressPercent = 0
      uploader.upload()
    },
    releaseLock() {
      this.isUploading = false
      this.eventBus.emit('release-lock')
    },
    saveVideoId(videoId) {
      this.eventBus.emit('video-uploaded-callback', videoId)
    },
    deleteVideo() {
      this.eventBus.emit('video-deleted-callback')
    },
  },
  computed: {
    vimeoSrc() {
      return 'https://player.vimeo.com/video/' + this.videoId
    },
  },
  mounted() {
    this.videos = this.videoList
  },
  created() {
    if (!this.eventBus) {
      return false
    }
    this.eventBus.on('videos-updated', this.videosUpdated)
  },
}
</script>

<style lang="scss">
@import 'VideoUpload.scss';
</style>
